import i18n from "../i18n"
import { LoadingService } from "react-ui-components/components/LoadingService"

export async function initializeLocalization() {
  LoadingService.show()
  try {
    await i18n.init()
  } finally {
    LoadingService.hide()
  }
}

